
import request from '../../requests/requests';
import { Api } from '../../config/api';
import { configs } from '../../config/config';

export function createCustom(data){
    return request({
        url:Api.customs.create,
        method:configs.http.request.methodPost,
        data
    })
}

export function getCustomList(data){
    return request({
        url:Api.customs.list,
        method:configs.http.request.methodGet,
        data
    })
}


export function getCustom(data){
    return request({
        url:Api.customs.get+data.id,
        method:configs.http.request.methodGet,
        data
    })
}

export function editCustom(data){
    return request({
        url:Api.customs.edit,
        method:configs.http.request.methodPost,
        data
    })
}